/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const ElectricGuitarIcon = createIcon(
  '0 0 20 20',
  <path d="M12.023 2c1.784 0 3.232 1.343 3.232 3 0 1.314-.911 2.431-2.179 2.837L15.271 14c-1.342 0-2.3.736-2.546 1.576-.063.217-.062.436-.062.66V18H7.41v-1.5c.036-1.5-1.737-2-1.737-2L8.73 4.76C9.22 3.193 10.246 2 12.023 2m-8.59 10.958a.8.8 0 1 1 1.526.482.8.8 0 0 1-1.526-.482m.632-2.003a.8.8 0 1 1 1.526.482.8.8 0 0 1-1.527-.482m.631-2.003a.8.8 0 1 1 1.527.482.8.8 0 0 1-1.527-.482m.632-2.002a.8.8 0 1 1 1.527.481.8.8 0 0 1-1.527-.482m.632-2.003a.8.8 0 1 1 1.527.483.8.8 0 0 1-1.527-.483m.631-2.003a.8.8 0 1 1 1.527.483.8.8 0 0 1-1.527-.483" />,
);
